import { useMemo } from 'react';

import { useIdempotenceKey } from '@gasbi/shared/common/hooks/useIdempotenceKey';
import { MultiStepFormModal } from '@gasbi/shared/web/components/MultiStepFormModal';
import { useParams } from 'react-router-dom';

import { useCreateSubdivisionMutation } from '@/features/subdivisions/subdivisionsApi';

import { getFormConfig } from './formConfig';
import {
  CreateSubdivisionFormSteps,
  CreateSubdivisionFormValues,
} from './types';

const messageConfig = {
  dialogTitle: 'Структурний підрозділ',
  toggleButton: 'Додати підрозділ',
  dialogSubtitle: 'Створення',
  submitButton: 'Створити',
};

interface Props {
  onClose: () => void;
}

/** «Додати підрозділ» of the ГРМ's підрозділи (the shared list's createSubdivisionForm), in steps (GSB-8433). */
export const CreateSubdivisionFormModal = ({ onClose }: Props) => {
  const { orgId = '' } = useParams<{ orgId: string }>();
  const formConfig = useMemo(() => getFormConfig(orgId), [orgId]);

  // A new key for the form, as the single-page form had.
  useIdempotenceKey(true);

  return (
    <MultiStepFormModal<CreateSubdivisionFormValues, CreateSubdivisionFormSteps>
      isOpen
      onClose={onClose}
      messageConfig={messageConfig}
      useMutation={useCreateSubdivisionMutation}
      formConfig={formConfig}
    />
  );
};
